import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { Button, Checkbox, Dropdown, Form, Notification, Toast } from '@douyinfe/semi-ui';
import { useRouter } from 'next/router';
import useRequest from '@/utils/useRequest';
import { IndexContext } from '@/stores';
import { debounce } from 'lodash';
import { PRODDOMAIN } from '@/utils';
import classNames from 'classnames';

interface IProps {
}

export default ({ }) => {
  const router = useRouter()
  const request = useRequest()
  const formRef = useRef<any>()
  const pswFormRef = useRef<any>()
  const vcode_key = useRef<number>(new Date().getTime())
  const [reload, setReload] = useState<any>(`${PRODDOMAIN}/visitor/ajax/get_verify?key=${vcode_key}`)
  const [isPhone, setIsPhone] = useState<any>(true)
  const [isForget, setIsForget] = useState<any>(false)
  const checkbox = useRef<any>()
  const { setIsHeadFoot, setLang } = useContext(IndexContext);
  const [countdown, setCountdown] = useState(0);
  const timerRef = useRef<any>();


  const btnClick = useCallback(async () => {

    // const { mobile, sms_code } = formRef.current?.getFormState().values
    console.log(formRef.current, pswFormRef.current);

    pswFormRef.current.validate().then(async () => {
      const params =
      // isPhone ? {
      //   mobile,
      //   sms_code
      // } : 
      {
        ...pswFormRef.current?.getFormState().values,
        user_type: 2
      }
      const { data } = await request.post("/visitor/do_login", params)
      if (data?.code == 1) {
        // let user = data?.data?.payload || {}
        // localStorage.setItem('token', window.btoa('123'))
        document.cookie = `v_token=${data?.data?.jwt}; Expires=${new Date(data?.data?.payload?.expire * 1000).toUTCString()}; Path=/; Secure; SameSite=Lax`;
        localStorage.setItem('user', window.btoa(JSON.stringify(data?.data?.payload)))
        const to = router.query.to as string
        router.push(to || 'https://visitor.organic-festa.com/register/en/index')
      } else {
        Toast.error(data?.msg)
      }
    }).catch((err: any) => {
      console.log(err);

      Toast.error(Object.values(err).join(' '))
    })

  }, [])

  const forget = useCallback(async () => {

    const { sms_code } = formRef.current?.getFormState().values
    console.log(formRef.current, formRef.current?.getFormState().values);

    formRef.current.validate().then(async () => {
      const { data } = await request.post("/visitor/forget_pwd", {
        ...formRef.current?.getFormState().values,
        vcode: sms_code
      })
      if (data?.code == 1) {
        Toast.success("Modify successfully")
        setIsForget(false)
      } else {
        Toast.error(data?.msg)
      }
    }).catch((err: any) => {
      Toast.error(Object.values(err).join(' '))
    })

  }, [])

  const sendCaptcha = useCallback(async () => {
    const { email, vcode } = formRef.current.getFormState().values

    if (!email) {
      Toast.error('Please enter your email')
      return
    }
    if (!vcode) {
      Toast.error('Please enter the graphic verification code')
      return
    }
    try {
      const { data: test } = await request.post('/visitor/check_account', {
        account: email
      })
      if (test?.code != 1) {
        Toast.error(test?.msg)
        return
      }
      const { data } = await request.post('/visitor/ajax/send_email_code', {
        email, vcode,
        vcode_key: vcode_key.current
      })
      if (data?.code != 1) {
        vcode_key.current = new Date().getTime()
        setReload(`${PRODDOMAIN}/visitor/ajax/get_verify?key=${vcode_key.current}`)
        Toast.error(data?.msg)
        return
      }
      // 开始倒计时
      setCountdown(60);
    } catch (error) {
      console.error('Failed to send: ', error);
      setCountdown(0); // 出错时重置状态
    }
  }, []);

  useEffect(() => {
    setIsHeadFoot(false)
    // router.push(jwt ? '/index' : '/login')
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
      setIsHeadFoot(true)
    }
  }, [])

  useEffect(() => {
    if (countdown > 0) {
      timerRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timerRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timerRef.current);
  }, [countdown]);

  return (
    <div className={styles.container}>
      <div className={styles.rightBtns}>
        <Dropdown
          style={{ width: '175px' }}
          render={
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setLang('cn')}>中文</Dropdown.Item>
              <Dropdown.Item onClick={() => setLang('en')}>English</Dropdown.Item>
            </Dropdown.Menu>
          }
        >
          <div className={styles.langBtn}>
            <span>Language： </span>English
          </div>
        </Dropdown>
        {isForget ?
          <div className={styles.toHome} onClick={() => setIsForget(false)}>Back Login</div>
          : <a className={styles.toHome} href="https://www.organic-festa.com/en">Back Home</a>}
      </div>
      <div className={styles.left}>
        <img className={styles.logo} src="/image/logo-white.png" alt="" />
        <img src="/image/login-title-en.png" alt="" />
      </div>
      <div className={styles.right}>
        {isForget ?
          <div>
            <h2>Forget Password</h2>
            <Form
              getFormApi={(formApi: any) => formRef.current = formApi}
              labelWidth={0}
            >
              <div className={styles.form}>
                <Form.Input
                  field="email"
                  placeholder='Please enter your email'
                  noLabel
                  noErrorMessage
                  rules={[
                    { required: true, message: 'Please enter your email' },
                    {
                      validator: (rule, value) => {
                        const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                        return emailRegex.test(value);
                      }, message: 'Please enter a valid email address'
                    }
                  ]}
                />
                <div className={styles.vcode}>
                  <Form.Input
                    field="vcode"
                    placeholder='Graph Validate Code'
                    noLabel
                    noErrorMessage
                    rules={[
                      { required: true, message: 'Please enter graph code' },
                    ]}
                  />
                  {reload && <img src={reload} onClick={() => {
                    vcode_key.current = new Date().getTime()
                    setReload(`${PRODDOMAIN}/visitor/ajax/get_verify?key=${vcode_key.current}`)
                  }} alt="" />}
                </div>
                <div className={styles.psw}>
                  <Form.Input
                    field="sms_code"
                    placeholder='Please enter the validate code'
                    noLabel
                    noErrorMessage
                    autoComplete='off'
                    rules={[
                      { required: true, message: 'Please enter the validate code' },
                    ]}
                  />
                  <Button
                    onClick={debounce(() => sendCaptcha(), 500)}
                    disabled={countdown > 0}
                  >{countdown > 0 ? `${countdown}s can send it again` : 'Send code'}</Button>
                </div>
                <Form.Input
                  field="password"
                  placeholder='Please enter your password'
                  noLabel
                  type='password'
                  noErrorMessage
                  autoComplete='off'
                  rules={[
                    { required: true, message: 'Please enter your password' },
                    {
                      pattern: /^.{6,16}$/,
                      message: 'The password must be 6-16 characters'
                    }
                  ]}
                />
                <Form.Input
                  field="verify_password"
                  placeholder='Please enter your confirm password'
                  noLabel
                  type='password'
                  noErrorMessage
                  autoComplete='off'
                  rules={[
                    { required: true, message: 'Please enter your confirm password' },
                    {
                      pattern: /^.{6,16}$/,
                      message: 'The password must be 6-16 characters'
                    }
                  ]}
                />
              </div>
              <div className={styles.login} onClick={debounce(() => forget(), 500)}>Save</div>
            </Form>
          </div>
          :
          <div>
            <h2>Visitor Center</h2>
            <p>Welcome to login <span>the OFA Visitor Center</span></p>
            <Form
              getFormApi={(formApi: any) => pswFormRef.current = formApi}
              labelWidth={0}
            >
              {
                (({ formState, values, formApi }) => (
                  <div className={styles.form}>
                    {/* <Form.RadioGroup
                      options={[{ label: 'Chinese mainland', value: '1' }, { label: 'Non-chinese mainland', value: '2' }]}
                      style={{ gap: '40px', marginBottom: '-20px' }}
                      field="user_type"
                      noLabel
                      direction="horizontal"
                      initValue={'2'}
                      disabled
                    /> */}
                    <div className={styles.account}>
                      <Form.Input
                        field="account"
                        placeholder='Please use email for login'
                        noLabel
                        noErrorMessage
                        rules={[
                          { required: true, message: 'Please use email for login' },
                        ]}
                      />
                    </div>
                    <div>
                      <Form.Input
                        field="pwd"
                        placeholder='Please enter your password'
                        noLabel
                        type='password'
                        noErrorMessage
                        rules={[
                          { required: true, message: 'Please enter your password' },
                        ]}
                      />
                    </div>
                  </div>
                ))}
            </Form>
            {/* } */}
            <p className={styles.forget} onClick={() => setIsForget(true)}>Forget your password?</p>
            <div className={styles.login} onClick={debounce(() => btnClick(), 500)}>Login</div>
            <a href="https://visitor.organic-festa.com/register/en/register">Register</a>
          </div>}
      </div>
      <style jsx global>
        {
          `
            .semi-form-field{
              // padding:0;
            }
            .semi-input-wrapper{
              border: none !important;
              background:#f3f5f9 !important;
              height:54px;              
            }
            .semi-input{
              height:100%;
              padding-right:142px;
              padding-left:20px;
            }
            .semi-input-wrapper:hover {
              border: none;
              background:#f3f5f9;
            }
          `
        }
      </style>
    </div>
  );
};
